import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import Navbar from "../components/Navbar";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) toast.error("Missing reset token");
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== pw2) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not reset password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="reset-password-page">
      <Navbar />
      <div className="px-6 py-16 max-w-md mx-auto">
        <div className="text-xs uppercase tracking-[0.4em] text-stone-500 mb-3">Choose a new password</div>
        <h1 className="font-serif-display text-5xl font-light mb-10">Reset password.</h1>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="reset-password" type="password" placeholder="New password (min 8 chars)" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full px-4 py-3 bg-white border border-stone-300 outline-none focus:border-stone-900" required />
          <input data-testid="reset-password-confirm" type="password" placeholder="Confirm new password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full px-4 py-3 bg-white border border-stone-300 outline-none focus:border-stone-900" required />
          <button data-testid="reset-submit" disabled={busy || !token} className="w-full py-3 bg-stone-900 text-white uppercase tracking-[0.3em] text-xs hover:bg-stone-800 disabled:opacity-40">{busy ? "Updating..." : "Update password"}</button>
          <div className="text-sm text-stone-600 mt-4"><Link to="/login" className="underline underline-offset-4">Back to sign in</Link></div>
        </form>
      </div>
    </div>
  );
}
